import * as angular from 'angular';
import {IController, IWindowService} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";
import {Expense} from "../../../expenses/models/expenses.model";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {ServicesService} from "../../services/services-service.service";
import {CommissionsDialogService} from "../../../commissions/services/commissions-dialogs-service.service";
import {CommissionsService} from "../../../commissions/services/commissions-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {ExpenseStatus} from "../../../expenses/types/expenses-status.type";
import {ExpensesDialogService} from "../../../expenses/services/expenses-dialog.service";
import {ExpensesService} from "../../../expenses/services/expenses-service.service";
import {take} from "rxjs";
import {TimeCardModel} from "../../../timekeeping/angular/models";
import {resolveFieldValue} from "../../../timekeeping/utils/field.util";
import * as moment from "moment/moment";
import {
  TimekeepingHttpService
} from "../../../timekeeping/angular/services/timekeeping-http.service";

export class DeliveriesGroupSelectorCtrl implements IController {
  operation: any;
  isShowServiceLink: any;
  hasRevertedTask: boolean;

  public siteInfo: any;
  private openInfoSection: any;
  private programTypesMap: any;
  private configZoneId: any;
  private serviceAreasIds: any;
  public showEditOmsOrderButton: boolean;
  public totalExpensesPrice: number;
  public canCreateTag: boolean;
  public serviceCopy?: any;
  public expenses?: Expense[];
  public isExposeAgentBranches: boolean;
  public isShowEditOrderButton: boolean;
  public isShowEditBranchesButton: boolean;
  public expenseStatusesTypes: typeof ExpenseStatus = ExpenseStatus;
  public latestTimecard: TimeCardModel | undefined = undefined;
  public timecardLink: string = ``;

  /* @ngInject */
  constructor(private splitService: SplitService, private $mdMedia, private $mdSidenav,
              private $state,
              private $window: IWindowService,
              private expensesDialogService: ExpensesDialogService,
              private expensesService: ExpensesService,
              private commissionsDialogService: CommissionsDialogService,
              private commissionsService: CommissionsService,
              private deliveriesService: DeliveriesService,
              private deliveriesDialogService: DeliveriesDialogService,
              private $log,
              private siteContextService: SiteContextService,
              private servicesService: ServicesService,
              private IAMPermissions,
              private timekeepingHttpService: TimekeepingHttpService,) {
    this.siteInfo = this.siteContextService.getSiteInfo();
  }

  $onInit() {
    if (this.IAMPermissions.hasPermission('expenses.list')) {
      this._getServiceExpenses(this.operation.id);
    }
    this.openInfoSection = this.$mdMedia('gt-sm');
    this.programTypesMap = this.splitService.getSiteProgramTypesMap();
    this.isExposeAgentBranches = this.splitService.getExposeAgentBranchesOnTheService();
    this.configZoneId = this.splitService.getTimeZone();
    this.serviceAreasIds = this.deliveriesService.getDeliveryServiceAreasIdsList(this.operation);
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');

    if (this.IAMPermissions.hasPermission('timekeeping.timeCard.list')) {
      this._loadLatestTimecard();
    }
  }

  $doCheck() {
    this.showEditOmsOrderButton = !this.$state.$current.includes['service.edit-operation'];
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  collapseInfoSection(event) {
    event.stopPropagation();
    this.openInfoSection = !this.openInfoSection;
  }

  toggleSidenav(event) {
    this.$mdSidenav('deliveryDetailNav').toggle();
  }

  onEditOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.edit', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank', 'width=1500,,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  }

  onEditBilling() {
    this.deliveriesService.getDeliveryBilling(this.operation.id)
      .then((billing) => {
        return this.deliveriesDialogService.editServiceBilling(this.operation.id, billing)
      })
      .then((editedBilling) => {
        this._updateServiceBilling(editedBilling);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })

  }

  onEditCommissionPrice(commissionId) {
    this.commissionsDialogService.editPrice()
      .then((payload) => {
        this.commissionsService.editPrice(commissionId, payload.price, payload.comment);
      })
  }

  onEditTags() {
    this.serviceCopy = angular.copy(this.operation);
  }

  onCancelEditTags() {
    this.serviceCopy = undefined;
  }

  onTagsChange(tagNames) {
    this.serviceCopy.tagNames = tagNames;
  }

  onUpdateTags(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.servicesService.updateCompletedService(this.operation.id, this.serviceCopy)
          .then((res) => {
            this.operation = res;
          })
          .finally(() => {
            this.serviceCopy = undefined;
          })
      }
    }
  }

  onEditReferenceIds(referenceIds, event) {
    this.deliveriesDialogService.editReferenceIds(referenceIds, this.operation.omsOrderReference?.id, event)
      .then((payload: { referenceIds: string[], updateOrder: boolean }) => {
        this._editReferenceIds(payload.referenceIds, payload.updateOrder);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEditExpense(expense, index, event) {
    this.expensesDialogService.editExpense(expense, event)
      .then((expense) => {
        this._updateExpense(expense, index);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to edit expense', error);
        } else {
          this.$log.debug('Dialog Closed');
        }
      })
  }

  private _updateServiceBilling(billing) {
    this.deliveriesService.updateServiceBilling(this.operation.id, billing)
      .catch((error) => {
        this.$log.info('Failed to update field service billing', error);
      })
  }

  private _getServiceExpenses(deliveryId: string) {
    this.servicesService.getServiceExpenses(deliveryId)
      .then((expenses: Expense[]) => {
        this.expenses = expenses;
        if (expenses.length) {
          this.totalExpensesPrice = expenses.reduce((sum, expense) => sum + expense.price, 0);
        }
      })
  }

  private _editReferenceIds(referenceIds: string[], updateOrder?: boolean) {
    this.servicesService.updateReferenceIds(this.operation.id, referenceIds, updateOrder)
      .then((updatedService) => {
        this.operation = updatedService;
      })
  }

  private _updateExpense(expense, index) {
    this.expensesService.updateExpense(expense)
      .then((updatedExpense) => {
        this.expenses[index] = updatedExpense;
      })
  }

  private _loadLatestTimecard() {
    const timeCardIds: Set<string> = this.operation.taskList.reduce((ids, task) => {
      if (task.timeCardId) {
        ids.add(task.timeCardId);
      }
      return ids;
    }, new Set<string>());


    if (!!timeCardIds.size) {
      this.timekeepingHttpService
        .getTimeCards({ ids: Array.from(timeCardIds), limit: timeCardIds.size })
        .pipe(take(1))
        .subscribe((timecards: { list: TimeCardModel[] }) => {
          if (!timecards || !timecards.list || timecards.list.length === 0) {
            this.latestTimecard = undefined;
          } else {
            this.latestTimecard = timecards.list.reduce((latest, current) => {
              return current.updatedAt > latest.updatedAt ? current : latest;
            });

            const date = resolveFieldValue(this.latestTimecard.clockInTimeField);
            const fromDate = moment(date).startOf('day').valueOf();
            const toDate = moment(date).endOf('day').valueOf();

            this.timecardLink = `timecardDetail({ agentId: "${this.latestTimecard.agentId}", from: "${fromDate}", to: "${toDate}" })`;
          }
        });
    }

  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('operationDetailPanel', {
    bindings: {
      operation: '<',
      isShowServiceLink: '<?',
      hasRevertedTask: '<?',
      onUpdateBranches: '&'
    },
    template: require('./operation-detail-panel.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
